import * as actions from './actions';
import state from './state';

export default {
  namespaced: true,
  actions,
  state,
};
